 :sm="6" :xs="6"<template>
    <div class="device-type-manange relative">
        <div class="buttons">
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="search">筛选</el-button>
        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="4" :lg="4" :xl="4" :sm="6" :xs="6" v-if="role_id != 2">
                <span class="fs-14 pd-r-10">确认人：</span>
                <el-input v-model="manager_name" placeholder="输入姓名"/>
            </el-col>
            <el-col :md="7" :lg="7" :xl="5" :sm="6" :xs="6">
                <span class="fs-14 pd-r-10">确认时间：</span>
                <el-date-picker
                        v-model="search_expired_date"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                ></el-date-picker>
            </el-col>
            <el-col :md="4" :lg="4" :xl="4" :sm="6" :xs="6" v-if="role_id != 2">
                <span class="fs-14 pd-r-10">健康管理专家：</span>
                <el-input v-model="doctor_name" placeholder="输入姓名"/>
            </el-col>
            <el-col :md="4" :lg="4" :xl="4" :sm="6" :xs="6">
                <span class="fs-14 pd-r-10">健康管理对象：</span>
                <el-input v-model="client_name" placeholder="输入姓名"/>
            </el-col>
        </el-row>
        <!-- 表单结束 -->
        <div class="docker_buttons" v-if="role_id != 2">
            <el-button type="primary" :id="'doctorDownload'" @click="exportExcel">导出数据</el-button>
        </div>

        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%">
<!--            <el-table-column prop="id" label="ID" align="center" label-class-name="label"></el-table-column>-->
            <el-table-column width="50" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="client_name" label="健康管理对象" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="manager_name" label="确认人" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="doctor_name" label="预约健康管理专家" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="meet_timestamp" label="会面时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="clock_date" label="确认时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="status_name" label="详情" align="center" label-class-name="label">
                <template slot-scope="scope">
                    <el-button :id="'doctorEdit'" @click="goEdit(scope.row)"
                           type="text" size="mini">查看
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column
                    prop="status_name"
                    label="状态"
                    align="center"
                    label-class-name="label"
            >
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page.sync="page"
                @current-change="changePage"
                @size-change="changeSite"
                v-if="is_pagination_show"
        ></el-pagination>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";
    import {getUserInfos} from "@/utils/userInfos";
    import {authUrlCheck} from "@/api/order";

    export default {
        data() {
            return {
                role_id: 0,
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                allSiginType: [
                    {
                        id: 1,
                        name: '外勤'
                    },
                    {
                        id: 2,
                        name: '预约'
                    },
                ],
                user_id: '',
                client_name: '',
                doctor_name: '',
                manager_name: '',
                signin_type: '',
                end_date: '',
                start_date: '',
                search_expired_date: '',
                is_submit: false,
                is_pagination_show: true
            };
        },
        created() {
            let userInfo = getUserInfos()
            if (userInfo) {
                this.role_id = parseInt(userInfo.role_id)
            }

            if (this.$route.params.user_id) {
                this.user_id = this.$route.params.user_id;
                this.manager_name = this.$route.params.user_name;
            }

        },
        mounted() {
            let prev_page = localStorage.getItem('prev_page');
            if (prev_page == 'work_detail') {
                this.user_id = localStorage.getItem('recept_list_user_id')
                this.client_name = localStorage.getItem('recept_list_client_name')
                this.doctor_name = localStorage.getItem('recept_list_doctor_name')
                this.manager_name = localStorage.getItem('recept_list_manager_name')
                this.end_date = localStorage.getItem('recept_list_end_date')
                this.start_date = localStorage.getItem('recept_list_start_date')
                this.page = parseInt(localStorage.getItem('page'))
                this.perpage = parseInt(localStorage.getItem('perpage'))
                if ( this.user_id == 'undefined' || this.user_id == 'null') {
                    this.user_id = ''
                }
                if ( this.client_name == 'undefined' || this.client_name == 'null') {
                    this.client_name = ''
                }
                if ( this.doctor_name == 'undefined' || this.doctor_name == 'null') {
                    this.doctor_name = ''
                }
                if ( this.manager_name == 'undefined' || this.manager_name == 'null') {
                    this.manager_name = ''
                }
                if ( this.end_date == 'undefined' || this.end_date == 'null') {
                    this.end_date = ''
                }
                if ( this.start_date == 'undefined' || this.start_date == 'null') {
                    this.start_date = ''
                }
                localStorage.setItem('prev_page', 'recept_list')
                this.is_pagination_show = false
            }
            this.getList();

        },
        methods: {
            // 获取所有医生
            getList() {
                let params = {
                    servername: 'Ruyi_AssistantAdminServices',
                    method: 'assistantClock',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        user_id: this.user_id,
                        client_name: this.client_name,
                        doctor_name: this.doctor_name,
                        manager_name: this.manager_name,
                        end_date: this.end_date,
                        start_date: this.start_date,
                    }
                };
				
                this.$api.service(params).then(res => {
                    if(res.data.code == 0)
                    {
                        let i = 0;
                        this.tableData = res.data.data.list;
                        this.total = res.data.data.page.count;
                        this.tableData.forEach(el=>{
                            // 序号
                            el.no = (this.page - 1) * this.perpage + i + 1
                            i++
                            switch (el.status)
                            {
                                case "1":el.status_name = "预约处理"; break;
                                case "2":el.status_name = "等待会面";break;
                                case "3":el.status_name = "会面完成";break;
                                case "4":el.status_name = "会面中断";break;
                            }

                        })

                    }

                    localStorage.setItem('recept_list_user_id', this.user_id)
                    localStorage.setItem('recept_list_client_name', this.client_name)
                    localStorage.setItem('recept_list_doctor_name', this.doctor_name)
                    localStorage.setItem('recept_list_manager_name', this.manager_name)
                    localStorage.setItem('recept_list_end_date', this.end_date)
                    localStorage.setItem('recept_list_start_date', this.start_date)
                    localStorage.setItem('prev_page', 'recept_list')
                    localStorage.setItem('page', this.page)
                    localStorage.setItem('perpage', this.perpage)
                    this.is_pagination_show = true
                }).catch(()=>{
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 重置按钮
            resetForm() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.user_id = "";
                this.client_name = "";
                this.doctor_name = "";
                this.manager_name = "";
                this.end_date = "";
                this.start_date = "";
                this.search_expired_date = "";
                this.page = 1;
                this.getList();
            },

            // 搜索
            search() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                if (this.search_expired_date) {
                    this.start_date = this.search_expired_date[0];
                    this.end_date = this.search_expired_date[1];
                }

                this.page = 1;
                this.getList();
            },

            // 编辑
            goEdit(data) {
                if (this.role_id > 1) {
                    if (!authUrlCheck('/admin/work/WorkDetail', this.$store.getters.authUrl)) {
                        return;
                    }
                }
                this.$router.push({
                    name: "workDetail",
                    params: {
                        reservation_id: data.reservation_id,
                    }
                });
                return;
            },

            // 导出数据
            exportExcel() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                let params = {
                    servername: 'Ruyi_AssistantAdminServices',
                    method: 'exportAssistantClock',
                    params: {
                        title_name: this.title_name,
                        status: this.status,
                        user_id: this.user_id,
                        client_name: this.client_name,
                        doctor_name: this.doctor_name,
                        manager_name: this.manager_name,
                        end_date: this.end_date,
                        start_date: this.start_date,
                    },
                };
 
                let colums_list = [
                    {title: "ID", key: "id"},
                    {title: "顾客", key: "client_name"},
                    {title: "确认人", key: "manager_name"},
                    {title: "预约健康管理专家", key: "doctor_name"},
                    {title: "确认时间", key: "create_date"},
                    {title: "状态", key: "status"},
                ];
                let export_data = [];
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }

                    let res_data = res.data;
                    if (parseInt(res_data.code) != 0) {
                        this.$message.error(res_data.msg);
                        this.is_submit = false;
                        return false;
                    }
                    if (!res.data.data) {
                        this.$message({
                            type: "error",
                            message: '暂无导出数据'
                        });
                        this.is_submit = false;
                        return;
                    }

                    for (var i = 0; i < res.data.data.length; i++) {
                        switch (res.data.data[i].status) {
                            case '1':
                                res.data.data[i].status = '预约处理';
                                break;
                            case '2':
                                res.data.data[i].status = '等待会面';
                                break;
                            case '3':
                                res.data.data[i].status = '会面完成';
                                break;
                             case '4':
                                res.data.data[i].status = '会面中断';
                                break;
                                
                        }

                        let item = {
                            id: res.data.data[i].id,
                            client_name: res.data.data[i].client_name,
                            manager_name: res.data.data[i].manager_name,
                            doctor_name: res.data.data[i].doctor_name,
                            create_date: res.data.data[i].create_date,
                            status: res.data.data[i].status,
                        };
                        export_data.push(item);


                    }

                    export2Excel(colums_list, export_data, "导出确认接待记录");
                    setTimeout(function () {
                        _that.is_submit = false;
                    }, 1500)
                }).catch(()=>{
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            }


        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
</style>
